import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SmsService } from 'src/app/services/sms-service/smsservice';

@Component({
  selector: 'app-turns-new-desk-dashboard',
  templateUrl: './turns-new-desk-dashboard.component.html',
  styleUrls: ['./turns-new-desk-dashboard.component.scss']
})
export class TurnsNewDeskDashboardComponent implements OnInit {

  smsList;
  deskTypes;
  centerList;
  getSmsListSubscription: Subscription;
  getTicketListSubscription: Subscription;
  getDeskTypesSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private smsService: SmsService,
              private desksTurnsService: DesksTurnsService,
              private snackbarService: SnackBarService,
              private userStorageService: UserStorageService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getSmsList();
    this.getDeskTypes();
    this.centerList = this.userStorageService.getCenterList();
  }

  private getSmsList() {
    this.getSmsListSubscription = this.smsService.getSmsList().subscribe(
      (res) => {
        this.smsList = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getDeskTypes() {
    this.getDeskTypesSubscription = this.desksTurnsService.getDeskTypes().subscribe(
      (res) => {
        this.deskTypes = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-desktop', 'turns-page.new desk', '/turns/desks', [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.desks', '/turns/desks'), new BRoute('turns-page.new desk')]));
  }
}
